var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-pp-message":"","data-pp-offer":_vm.type,"data-pp-style-text-align":_vm.alignment}})
}
var staticRenderFns = []

export { render, staticRenderFns }